import { memo, useState, useMemo } from "react";
import Card from "./Card";
import "./ChefComponent.css";

const VerifiedChefComponent = memo(
  ({
    handleChefLocation,
    handleShowMenu,
    handleUnVerifyChef,
    handleChefStatus,
    handleProfileUpdate,
    handleChefImage,
    handleChefDesc,
    handleKitchenImages,
    handleEmiStatus,
    chefLevelData,
    handlePerformance,
    handleMenuCount,
    handleCraverNotifications,
    showActive,
    setShowActive,
    handleInitiateChefChat,
    podLocations
  }) => {
    const [selectedPod, setSelectedPod] = useState("");

    const activeChefs = chefLevelData.filter((data) => data.isUserAvailable);
    const inactiveChefs = chefLevelData.filter((data) => !data.isUserAvailable);

    const filteredActiveChefs = useMemo(() => {
      if (!selectedPod) return activeChefs;
      return activeChefs.filter(
        (chef) =>
          chef.podName?.toLowerCase() === selectedPod.toLowerCase()
      );
    }, [activeChefs, selectedPod]);

    const filteredInactiveChefs = useMemo(() => {
      if (!selectedPod) return inactiveChefs;
      return inactiveChefs.filter(
        (chef) =>
          chef.podName?.toLowerCase() === selectedPod.toLowerCase()
      );
    }, [inactiveChefs, selectedPod]);

    const handleChefNewMenu = (data) => {
      window.open(
        `/newChefMenu?chefID=${data.userID}&kitchenName=${data.userKitchen}&ChefName=${data.userName}&mobileNumber=${data.userMobile}`,
        "_blank"
      );
    };

    const renderCards = (dataList) => {
      return dataList.map((data) => (
        <Card
          type="Verified"
          key={data.userID}
          data={data}
          handleShowMenu={handleShowMenu}
          handleUnVerifyChef={handleUnVerifyChef}
          handleChefStatus={handleChefStatus}
          handleChefNewMenu={handleChefNewMenu}
          handleProfileUpdate={handleProfileUpdate}
          handleChefImage={handleChefImage}
          handleChefDesc={handleChefDesc}
          handleKitchenImages={handleKitchenImages}
          handleEmiStatus={handleEmiStatus}
          handlePerformance={handlePerformance}
          handleMenuCount={handleMenuCount}
          handleCraverNotifications={handleCraverNotifications}
          handleInitiateChefChat={handleInitiateChefChat}
          handleChefLocation={handleChefLocation}
        />
      ));
    };

    return (
      <>
        <div className="mb-3 d-flex justify-content-center align-items-center">
          <label className="me-2 fw-bold mt-2 mr-2">Filter by Pod Location:</label>
          <select
            className="form-select w-auto"
            value={selectedPod}
            onChange={(e) => setSelectedPod(e.target.value)}
          >
            <option value="">All Locations</option>
            {podLocations.map((loc) => (
              <option key={loc.podID} value={loc.podName}>
                {loc.podName}
              </option>
            ))}
          </select>
        </div>

        <div
          className="btn-group btn-group-sm mb-3"
          role="group"
          aria-label="Small button group"
        >
          <button
            type="button"
            className={`btn ${showActive ? "btn-primary" : "btn-outline-dark"}`}
            onClick={() => setShowActive(true)}
          >
            Available Chefs - {filteredActiveChefs.length}
          </button>
          <button
            type="button"
            className={`btn ${!showActive ? "btn-primary" : "btn-outline-dark"}`}
            onClick={() => setShowActive(false)}
          >
            Unavailable Chefs - {filteredInactiveChefs.length}
          </button>
        </div>

        <div className="rowDisplayCards">
          {showActive
            ? renderCards(filteredActiveChefs)
            : renderCards(filteredInactiveChefs)}
        </div>
      </>
    );
  }
);

export default VerifiedChefComponent;
